// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Stock Transfer Out — typography & controls aligned with Create PO / global portal (body: 0.875rem, Montserrat, weight 500) */

.sto-create-root {
  font-size: 0.875rem;
  font-weight: 500;
}

.sto-create-root .form-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: inherit;
  margin-bottom: 0.35rem;
}

.sto-create-root .form-control,
.sto-create-root .form-select {
  font-family: inherit;
  font-weight: 500;
  font-size: 0.875rem;
  border-radius: 0.375rem;
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
}

.sto-create-root .form-control:focus,
.sto-create-root .form-select:focus {
  box-shadow: none;
  border-color: #222;
}

.sto-create-root textarea.form-control[readonly] {
  background-color: #e9ecef;
  color: inherit;
  font-size: 0.875rem;
  font-weight: 500;
  resize: none;
}

.sto-section {
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 0.75rem;
  background: #fff;
  margin-bottom: 1.25rem;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.sto-section-header {
  padding: 0.65rem 1.15rem;
  background: linear-gradient(180deg, #f8f9fa 0%, #eef1f4 100%);
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
  font-weight: 600;
  font-size: 0.875rem;
  color: inherit;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.sto-section-header i {
  opacity: 0.85;
  font-size: 0.875rem;
}

.sto-section-body {
  padding: 1.15rem 1.25rem 1.25rem;
}

.sto-route-grid {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 1rem 0.75rem;
  align-items: stretch;
}

@media (max-width: 991.98px) {
  .sto-route-grid {
    grid-template-columns: 1fr;
  }
  .sto-route-arrow {
    display: none !important;
  }
}

.sto-route-card {
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 0.65rem;
  padding: 1rem;
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
}

.sto-route-card--dest {
  background: linear-gradient(145deg, #ffffff 0%, #f0f7ff 100%);
  border-color: rgba(13, 110, 253, 0.15);
}

.sto-route-card-title {
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: none;
  letter-spacing: normal;
  color: inherit;
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.35rem;
}

.sto-route-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  font-size: 0.875rem;
  padding-top: 2rem;
}

.sto-summary-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 1.5rem;
  padding: 1rem 1.15rem;
  background: #f8f9fa;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 0.65rem;
  margin-bottom: 1rem;
}

.sto-summary-item label {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  text-transform: none;
  letter-spacing: normal;
  color: inherit;
  margin-bottom: 0.2rem;
}

.sto-summary-item .sto-summary-value {
  font-size: 0.875rem;
  font-weight: 600;
  color: inherit;
  line-height: 1.5;
  font-variant-numeric: tabular-nums;
}

.sto-items-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.85rem;
}

.sto-items-toolbar h6 {
  font-size: 0.875rem;
  font-weight: 600;
  color: inherit;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.sto-items-toolbar .badge {
  font-size: 0.875rem;
  font-weight: 500;
}

.sto-items-toolbar .btn-add-line {
  font-weight: 500;
  font-size: 0.875rem;
  padding: 0.375rem 0.75rem;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.sto-items-table-wrap {
  border: 1px solid rgba(15, 23, 42, 0.1);
  border-radius: 0.65rem;
  overflow: auto;
  max-width: 100%;
}

.sto-items-table-wrap table {
  margin-bottom: 0;
  min-width: 920px;
}

.sto-items-table-wrap thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #334155 !important;
  color: #f8fafc !important;
  font-weight: 600;
  font-size: 0.875rem;
  text-transform: none;
  letter-spacing: normal;
  white-space: nowrap;
  padding: 0.65rem 0.5rem;
  border: none;
  vertical-align: middle;
}

.sto-items-table-wrap tbody td {
  vertical-align: middle;
  padding: 0.5rem 0.45rem;
  border-color: rgba(15, 23, 42, 0.06);
  font-size: 0.875rem;
  font-weight: 500;
}

.sto-items-table-wrap tbody tr:hover td {
  background: rgba(13, 110, 253, 0.045);
}

.sto-items-table-wrap .form-control {
  min-height: calc(1.5em + 0.75rem + 2px);
}

.sto-items-table-wrap input[readonly].form-control {
  background-color: #e9ecef;
  font-weight: 500;
  color: inherit;
}

.sto-line-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2.125rem;
  height: calc(1.5em + 0.75rem + 2px);
  border-radius: 0.375rem;
  background: #e9ecef;
  color: inherit;
  font-weight: 600;
  font-size: 0.875rem;
}

.sto-items-table-wrap .btn-remove-line {
  font-size: 0.875rem;
  font-weight: 500;
  padding: 0.375rem 0.75rem;
  white-space: nowrap;
}

.sto-footer-actions {
  padding-top: 0.5rem;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  margin-top: 1.25rem;
}

.sto-footer-actions .btn {
  font-size: 0.875rem;
  font-weight: 500;
  padding: 0.375rem 0.75rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Grn/add-stock-transfer-out.css"],"names":[],"mappings":"AAAA,+HAA+H;;AAE/H;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;EACxB,6DAA6D;EAC7D,+CAA+C;EAC/C,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,aAAa;EACb,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,wCAAwC;EACxC,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;EACnC,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B","sourcesContent":["/* Stock Transfer Out — typography & controls aligned with Create PO / global portal (body: 0.875rem, Montserrat, weight 500) */\n\n.sto-create-root {\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.sto-create-root .form-label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: inherit;\n  margin-bottom: 0.35rem;\n}\n\n.sto-create-root .form-control,\n.sto-create-root .form-select {\n  font-family: inherit;\n  font-weight: 500;\n  font-size: 0.875rem;\n  border-radius: 0.375rem;\n  padding: 0.375rem 0.75rem;\n  line-height: 1.5;\n}\n\n.sto-create-root .form-control:focus,\n.sto-create-root .form-select:focus {\n  box-shadow: none;\n  border-color: #222;\n}\n\n.sto-create-root textarea.form-control[readonly] {\n  background-color: #e9ecef;\n  color: inherit;\n  font-size: 0.875rem;\n  font-weight: 500;\n  resize: none;\n}\n\n.sto-section {\n  border: 1px solid rgba(15, 23, 42, 0.08);\n  border-radius: 0.75rem;\n  background: #fff;\n  margin-bottom: 1.25rem;\n  overflow: hidden;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.sto-section-header {\n  padding: 0.65rem 1.15rem;\n  background: linear-gradient(180deg, #f8f9fa 0%, #eef1f4 100%);\n  border-bottom: 1px solid rgba(15, 23, 42, 0.08);\n  font-weight: 600;\n  font-size: 0.875rem;\n  color: inherit;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.sto-section-header i {\n  opacity: 0.85;\n  font-size: 0.875rem;\n}\n\n.sto-section-body {\n  padding: 1.15rem 1.25rem 1.25rem;\n}\n\n.sto-route-grid {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  gap: 1rem 0.75rem;\n  align-items: stretch;\n}\n\n@media (max-width: 991.98px) {\n  .sto-route-grid {\n    grid-template-columns: 1fr;\n  }\n  .sto-route-arrow {\n    display: none !important;\n  }\n}\n\n.sto-route-card {\n  border: 1px solid rgba(15, 23, 42, 0.08);\n  border-radius: 0.65rem;\n  padding: 1rem;\n  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);\n}\n\n.sto-route-card--dest {\n  background: linear-gradient(145deg, #ffffff 0%, #f0f7ff 100%);\n  border-color: rgba(13, 110, 253, 0.15);\n}\n\n.sto-route-card-title {\n  font-size: 0.875rem;\n  font-weight: 600;\n  text-transform: none;\n  letter-spacing: normal;\n  color: inherit;\n  margin-bottom: 0.75rem;\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.sto-route-arrow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #94a3b8;\n  font-size: 0.875rem;\n  padding-top: 2rem;\n}\n\n.sto-summary-bar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem 1.5rem;\n  padding: 1rem 1.15rem;\n  background: #f8f9fa;\n  border: 1px solid rgba(15, 23, 42, 0.06);\n  border-radius: 0.65rem;\n  margin-bottom: 1rem;\n}\n\n.sto-summary-item label {\n  display: block;\n  font-size: 0.875rem;\n  font-weight: 500;\n  text-transform: none;\n  letter-spacing: normal;\n  color: inherit;\n  margin-bottom: 0.2rem;\n}\n\n.sto-summary-item .sto-summary-value {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: inherit;\n  line-height: 1.5;\n  font-variant-numeric: tabular-nums;\n}\n\n.sto-items-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.85rem;\n}\n\n.sto-items-toolbar h6 {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: inherit;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.sto-items-toolbar .badge {\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.sto-items-toolbar .btn-add-line {\n  font-weight: 500;\n  font-size: 0.875rem;\n  padding: 0.375rem 0.75rem;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.sto-items-table-wrap {\n  border: 1px solid rgba(15, 23, 42, 0.1);\n  border-radius: 0.65rem;\n  overflow: auto;\n  max-width: 100%;\n}\n\n.sto-items-table-wrap table {\n  margin-bottom: 0;\n  min-width: 920px;\n}\n\n.sto-items-table-wrap thead th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: #334155 !important;\n  color: #f8fafc !important;\n  font-weight: 600;\n  font-size: 0.875rem;\n  text-transform: none;\n  letter-spacing: normal;\n  white-space: nowrap;\n  padding: 0.65rem 0.5rem;\n  border: none;\n  vertical-align: middle;\n}\n\n.sto-items-table-wrap tbody td {\n  vertical-align: middle;\n  padding: 0.5rem 0.45rem;\n  border-color: rgba(15, 23, 42, 0.06);\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.sto-items-table-wrap tbody tr:hover td {\n  background: rgba(13, 110, 253, 0.045);\n}\n\n.sto-items-table-wrap .form-control {\n  min-height: calc(1.5em + 0.75rem + 2px);\n}\n\n.sto-items-table-wrap input[readonly].form-control {\n  background-color: #e9ecef;\n  font-weight: 500;\n  color: inherit;\n}\n\n.sto-line-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 2.125rem;\n  height: calc(1.5em + 0.75rem + 2px);\n  border-radius: 0.375rem;\n  background: #e9ecef;\n  color: inherit;\n  font-weight: 600;\n  font-size: 0.875rem;\n}\n\n.sto-items-table-wrap .btn-remove-line {\n  font-size: 0.875rem;\n  font-weight: 500;\n  padding: 0.375rem 0.75rem;\n  white-space: nowrap;\n}\n\n.sto-footer-actions {\n  padding-top: 0.5rem;\n  border-top: 1px solid rgba(15, 23, 42, 0.06);\n  margin-top: 1.25rem;\n}\n\n.sto-footer-actions .btn {\n  font-size: 0.875rem;\n  font-weight: 500;\n  padding: 0.375rem 0.75rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
